import * as allActions from "../../actions/actions.constants";

const initialState = null;

const emailActionReducer = (state = initialState, action) => {
  switch (action.type) {
    case allActions.SET_EMAIL_ACTION:
      return action.payload;
    case allActions.CLEAR_EMAIL_ACTION:
      return null;
    default:
      return state;
  }
};

export default emailActionReducer;
